import React from 'react'

export const MapLoader = () => (
	<div className="map-loader-spinner">
	  <i className="fa fa-spinner fa-spin fa-5x fa-fw" />
	  <br/>
	  <span className="loading-text">
	    Loading...
	  </span>
	</div>
)

export default MapLoader


// WEBPACK FOOTER //
// ./src/browser/components/users/mapSelector/mapLoader.js